import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IQuotation } from 'app/shared/model/quotation.model';
import { getEntities as getQuotations } from 'app/entities/quotation/quotation.reducer';
import { getEntity, updateEntity, createEntity, reset } from './purchase-cancellation.reducer';
import { IPurchaseCancellation } from 'app/shared/model/purchase-cancellation.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PurchaseCancellationUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const quotations = useAppSelector(state => state.quotation.entities);
  const purchaseCancellationEntity = useAppSelector(state => state.purchaseCancellation.entity);
  const loading = useAppSelector(state => state.purchaseCancellation.loading);
  const updating = useAppSelector(state => state.purchaseCancellation.updating);
  const updateSuccess = useAppSelector(state => state.purchaseCancellation.updateSuccess);
  const handleClose = () => {
    props.history.push('/purchase-cancellation' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getQuotations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...purchaseCancellationEntity,
      ...values,
      quotation: quotations.find(it => it.id.toString() === values.quotation.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...purchaseCancellationEntity,
          quotation: purchaseCancellationEntity?.quotation?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.purchaseCancellation.home.createOrEditLabel" data-cy="PurchaseCancellationCreateUpdateHeading">
            <Translate contentKey="comexApp.purchaseCancellation.home.createOrEditLabel">Create or edit a PurchaseCancellation</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="purchase-cancellation-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.purchaseCancellation.reason')}
                id="purchase-cancellation-reason"
                name="reason"
                data-cy="reason"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.purchaseCancellation.managerApproval')}
                id="purchase-cancellation-managerApproval"
                name="managerApproval"
                data-cy="managerApproval"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('comexApp.purchaseCancellation.comexAdminApproval')}
                id="purchase-cancellation-comexAdminApproval"
                name="comexAdminApproval"
                data-cy="comexAdminApproval"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('comexApp.purchaseCancellation.status')}
                id="purchase-cancellation-status"
                name="status"
                data-cy="status"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.purchaseCancellation.result')}
                id="purchase-cancellation-result"
                name="result"
                data-cy="result"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="purchase-cancellation-quotation"
                name="quotation"
                data-cy="quotation"
                label={translate('comexApp.purchaseCancellation.quotation')}
                type="select"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              >
                <option value="" key="0" />
                {quotations
                  ? quotations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/purchase-cancellation" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PurchaseCancellationUpdate;
